<template>
  <app-popup :active.sync="isActive" title="Экспорт шифрованных показаний">
    <div style="margin-bottom: 15px">
      <app-datepicker v-model="month" label="Месяц" format="MMMM yyyy" minimum-view="month"/>
    </div>
    <div style="text-align: center">
      <app-button color="success" :disabled="status === STATUSES.exporting" @click="exportData">{{status ===
        STATUSES.exporting ? 'Генерирую...' : 'Сгенерировать'}}
      </app-button>
    </div>
  </app-popup>
</template>

<script>

  const STATUSES = {
    default: 0,
    exporting: 1
  };

  export default {
    name: "ExportEncryptedValuesPopup",
    data() {
      return {
        isActive: false,
        status: STATUSES.default,
        STATUSES: STATUSES,
        month: null
      }
    },
    computed: {
      selectedMonth() {
        return this.$store.getters['appUser/selectedDate'];
      },
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      }
    },
    methods: {
      open() {
        this.isActive = true;
        this.month = this.selectedMonth;
      },
      async exportData() {
        try {
          this.status = STATUSES.exporting;

          let {data} = await this.$http.get('encoded_device_values/export', {
            params: {
              buildings_id: this.selectedHouseId,
              month: this.$options.filters.moment(this.selectedMonth, "YYYY-MM")
            }
          });

          this.$vs.notify({color: 'success', title: "Успешная генерация", text: 'Файл сгенерирован'});

          this.downloadFile(data.path);
        } catch (e) {
          console.error(e);
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
            } else {
              this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
            }
          } else {
            this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
          }
        } finally {
          setTimeout(() => {
            this.status = STATUSES.default;
          }, 300);
        }
      },
      downloadFile(url) {
        let link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('href', this.$options.filters.imgPath(url));
        link.setAttribute('download', url.split('/').pop());
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          link.remove();
        }, 500);
      },
    },
  }
</script>

<style lang="scss">

</style>
